<template>
    <el-form label-width="120px" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="用户名" required>
            <el-input v-model="form.username" clearable />
        </el-form-item>
        <el-form-item label="手机号" required>
            <el-input v-model="form.phone" clearable />
        </el-form-item>
        <el-form-item label="邀请码" required>
            <el-input v-model="form.invite" clearable />
        </el-form-item>
        <el-form-item label="登陆密码" required>
            <el-input v-model="form.password" clearable />
        </el-form-item>
        <el-form-item label="身份证名" required>
            <el-input v-model="form.sfz_name" clearable />
        </el-form-item>
        <el-form-item label="身份证号码" required>
            <el-input v-model="form.sfz_number" clearable />
        </el-form-item>
        <el-form-item label="实名状态" required>
            <el-select v-model="form.sfz_status" placeholder="" clearable>
                <el-option v-for="item in sfzStatusEnums" :label="item.label" :value="item.value" />
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script setup>
import { reactive } from 'vue'
import {limitEnums, booleanEnums, openEnums, memberLevelList, userlistSfzStatusEnums, sfzStatusEnums, clockEnums} from '@/config/enums'

const form = reactive({
    username: '',
    phone: '',
    invite: '',
    password: '',
    sfz_name: '',
    sfz_number: '',
    sfz_status: '',

    
})




defineExpose({form})
</script>

<style lang="less" scoped>
.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}
.form-title {
 text-align: left;
 padding-left: 30px;
 margin: 20px auto 10px;
 height: 44px;
 background-color: #f2f2f2;
 border-radius: 5px;
 line-height: 44px;
}
</style>